import React from "react";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
// import LinkMui from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import DashboardItems from "./DashboardItems";
import { useRouter } from "./../util/router";
import { useAuth } from "./../util/auth";


const useStyles = makeStyles((theme) => ({
  cardContent: {
    padding: theme.spacing(3),
  },
}));

function DashboardSection(props) {
  const classes = useStyles();

  const auth = useAuth();
  const router = useRouter();

  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={4}
          textAlign="center"
        />

        {router.query.paid && auth.user.planIsActive && (
          <Box mx="auto" mb={4} maxWidth={400}>
            <Alert severity="success">
              You are now subscribed to the {auth.user.planId} plan
              <span
                role="img"
                aria-label="party"
                style={{ marginLeft: "10px" }}
              >
                🥳
              </span>
            </Alert>
          </Box>
        )}

        <Grid container={true} spacing={4}>
          <Grid item={true} xs={12} md={6}>
            <DashboardItems />

          </Grid>

          <Grid item={true} xs={12} md={6}>
            <Card>
              <CardContent className={classes.cardContent}>
                <Box>
                  <Typography variant="h5" paragraph={true}>
                    <strong>  Hi <strong>{auth.user.name}</strong>!</strong>
                  </Typography>
                  <Typography component="div" variant="h6" >


                    <div>
                      You are <strong>{auth.user.stripeCustomerId ? "subscribed" : "not subscribed"}</strong> to a plan.
                    </div>
                    <div>
                      Your next class is <strong>{auth.user.class1 || auth.user.class2 || auth.user.class3}</strong>.
                    </div>

                    {auth.user.stripeCustomerId && (
                      <>

                        <div>
                          Your plan status is{" "}
                          <strong>
                            {auth.user.stripeSubscriptionStatus || "unknown"}
                          </strong>
                          .
                        </div>
                        <div>
                          You are signed in as <strong>{auth.user.email}</strong>.
                        </div>
                        <div>
                          You are subscribed to a{" "}
                          <strong>{auth.user.planId}  plan</strong>.
                        </div>
                      </>
                    )}
                  </Typography>
                </Box>

                {/* <Box mt={3}>
                  <Typography>
                    <div>
                      You can change your account info{` `}
                      {auth.user.stripeSubscriptionId && <>and plan{` `}</>}
                      in{` `}
                      <LinkMui component={Link} to="/settings/general">
                        <strong>settings</strong>
                      </LinkMui>
                      .
                    </div>

                    {!auth.user.stripeSubscriptionId && (
                      <div>
                        You can signup for a plan in{" "}
                        <LinkMui component={Link} to="/pricing">
                          <strong>pricing</strong>
                        </LinkMui>
                        .
                      </div>
                    )}
                  </Typography>
                </Box> */}


                <Box mt={3}>
                  <Typography variant="h6" paragraph={true}>
                    <strong>Extra debug info</strong>
                  </Typography>

                  <Typography paragraph={true}>
                    The component on your left is an example UI that shows you
                    how to fetch, display, and update a list of items that
                    belong to the current authenticated user. Try it now by
                    adding a couple items.
                  </Typography>
                  <Typography paragraph={true}>
                    It also shows how you can limit features based on plan. If
                    you're subscribed to the "pro" or "business" plan then
                    you'll be able to use the star button to highlight items,
                    otherwise you'll be asked to upgrade your plan.
                  </Typography>
          



                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Section>
  );
}

export default DashboardSection;
